import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { X, ArrowRight } from 'lucide-react';
const AFFICHE_URL = 'https://cdn.magicpatterns.com/uploads/4hxAWqSMUTmkMiaPwYmMZJ/PROMAISON_affiche_original_orthographe_fix.png';
export function PromaisonPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    // Only show once per browser session, and never on the PROMAISON page itself
    const alreadyShown = sessionStorage.getItem('promaison_popup_shown');
    if (alreadyShown || location.pathname === '/promaison') {
      return;
    }
    const timer = setTimeout(() => {
      setIsVisible(true);
      sessionStorage.setItem('promaison_popup_shown', 'true');
    }, 1200);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const close = () => setIsVisible(false);
  const goToPromaison = () => {
    setIsVisible(false);
    navigate('/promaison');
  };
  if (!isVisible) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-[fadeIn_0.3s_ease-out]" role="dialog" aria-modal="true" aria-label="Découvrez le programme PROMAISON" onClick={close} data-id="element-115">
      <div className="relative w-full max-w-lg animate-[popIn_0.4s_cubic-bezier(0.16,1,0.3,1)]" onClick={e => e.stopPropagation()} data-id="element-116">
        {/* Close button */}
        <button type="button" onClick={close} aria-label="Fermer" className="absolute -top-3 -right-3 z-10 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center text-gray-700 hover:bg-gray-100 transition-colors" data-id="element-117">
          <X className="w-5 h-5" data-id="element-118" />
        </button>

        {/* Clickable affiche */}
        <button type="button" onClick={goToPromaison} className="group block w-full rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/10 cursor-pointer focus:outline-none focus-visible:ring-4 focus-visible:ring-[#D4A574]" data-id="element-119">
          <img src={AFFICHE_URL} alt="PROMAISON par ADCC — Votre maison mérite mieux. Programme de renforcement de capacité des personnels de maison." className="w-full h-auto object-contain transition-transform duration-500 group-hover:scale-[1.02]" data-id="element-120" />
          {/* CTA ribbon over the bottom */}
          <span className="flex items-center justify-center gap-2 w-full py-4 bg-[#1E3A5F] text-white font-semibold text-base tracking-wide transition-colors group-hover:bg-[#152C47]" data-id="element-121">
            Découvrir le programme PROMAISON
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-122" />
          </span>
        </button>
      </div>
    </div>;
}